import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import {bin} from 'react-icons-kit/icomoon/bin';
import { FloatingActionButton } from 'material-ui';
import { ContentAdd } from 'material-ui/svg-icons';
import SvgIcon from 'react-icons-kit';
import tab from 'material-ui/svg-icons/action/tab';

var Config = require('../../../../config');

class ModalConditions extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.addToList = this.addToList.bind(this);
        this.deleteToList = this.deleteToList.bind(this);
        this.onSave = this.onSave.bind(this);
        
		this.state = {
            show: false,
            patient_id:"",
            table_list:[],
            condition:"",
            conditions:[]
		};
	}

	componentDidMount() {
        this.props.onRef(this);
        
        fetch(Config.default.apiGateway.URL+'patients/conditions/get_process', {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({conditions:response});
			}
		})
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ 
            show: false,
            patient_id:"",
            table_list:[],
            condition:"",
		});
	}

	handleShow(id) {
        fetch(Config.default.apiGateway.URL+'patients/conditions/'+id,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                var table = [];
                response.map((res)=>
                    table.push(res.blood_process)
                )
                
                this.setState({
                    show: true,
                    patient_id:id,
                    table_list: table
                });
            }
        })
        
    }

	handleChange(e){
        this.setState({
            [e.target.name]: e.target.value
        });	
    }
    
    
    addToList(){
        if(this.state.condition !== ""){
            var table = this.state.table_list;
            var index = table.findIndex(obj => obj === this.state.condition);
            
            if(index === -1){
                table.push(this.state.condition);
                this.setState({
                    table_list: table,
                    condition:""
                })
            }else{
                swal('Error', 'El proceso ya se encuentra en la lista', 'error');
            }
        }

    }

    deleteToList(e, i){
        e.preventDefault();

        var table = this.state.table_list;

        table.splice(i, 1);

        this.setState({
            table_list: table
        })

    }

    onSave(){
        this.props.waiting.handleShow('Guardando...');
        fetch(Config.default.apiGateway.URL+'patients/conditions/'+this.state.patient_id,{
            method:'POST',
            body:JSON.stringify(this.state.table_list),
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg)=>{
                    swal('Error', msg, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                this.handleClose();
            }
        })
    }

	render(){
		const { t } = this.props;
		return(
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Validación de Componentes</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
			        	<div className="col-xs-12 form-group">
                            <div className="col-xs-9">
                                <span className="span-min">Procesos</span>
                                <select className="form-control input-sm" id="condition" name="condition" value={this.state.condition} 
                                    onChange={(e)=>this.handleChange(e)}>
                                        <option value="">Seleccione...</option>
                                        {this.state.conditions.map((c, i)=>
                                            <option key={i} value={c}>{c}</option>
                                        )}
                                    </select>
                            </div>
                            <div className="col-xs-12 col-sm-1" style={{marginTop:'20px'}}>
                                <FloatingActionButton className="action-btn" iconStyle={{height: 25, width: 25}} mini={true} 
                                    onClick={()=>this.addToList()}>
                                    <ContentAdd/>
                                </FloatingActionButton>
                            </div>
                        </div>
                        <div className="col-xs-12 form-group">
                            <Table responsive hover>
                                <thead>
                                    <tr>
                                        <th>Proceso</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.table_list.map((t, i)=>
                                        <tr key={i}>
                                            <td>{t}</td>
                                            <td>
                                                <button className="btn btn-info" 
                                                    onClick={(e)=>this.deleteToList(e, i)}	>
                                                    <SvgIcon size={15} icon={bin} />
                                                    
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={()=>this.onSave()} />
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')} onClick={()=>this.handleClose()}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalConditions);